import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlListGroupTagNames } from './list-group.props';

@customElement(AtlListGroupTagNames.ActionListGroup)
export class AtlActionListGroup extends LitElement {
   static styles = [...getGlobalStyleSheets()];

   render() {
      return html` <div class="actions-list-group">
         <slot></slot>
      </div>`;
   }
}
